import { createContext } from 'react';

type ModalProviderType = {
  isModal: boolean;
  close: () => void;
};

export const ModalContext = createContext<ModalProviderType>({
  isModal: false,
  close: () => {},
});
